import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';

import { ReactComponent as SaveCollectionIcon } from "static/icons/save-collection.svg";

import UniversalButton from "components/uiComponents/UniversalButton";
import SaveCollectionModal from "components/modals/SaveCollectionModal";

import { ModalContext } from "components/ModalContext";

const SaveCollection = ({ tableInfo }) => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);

  const openModal = () =>
    handleModal(
      <SaveCollectionModal
        closeCollectionModal={closeModal}
        tableInfo={tableInfo}
      />
    );

  const closeModal = () => handleModal(null, true);

  return (
    <>
      <UniversalButton
        style={{ height: "32px" }}
        label={t('save_selection_set')}
        size="md"
        labelColor="blue"
        labelHoverColor="blue"
        backgroundColor="blue"
        backgroundHoverColor="$blue"
        leftIcon={<SaveCollectionIcon />}
        onClick={openModal}
        isRounded="sm"
      />
    </>
  );
};

export default SaveCollection;
